export const APP_SECTIONS_PATHS = {
  ROOT: '/',
  BASE_APP: '/app',
  DAP: '/dap',
  MY_PLANS: '/my-plans',
  CATALOG: '/catalog',
  PROGRESS: '/progress',
  MILESTONES: '/milestones',
  SETTINGS: '/settings',
  SETTINGS_STAFF: '/settings-staff',
  ADD_STUDENTS: '/add-students',
  STUDENTS_PROFILE: '/student-profile',
  USER_PROFILE: '/user-profile',
  ON_BOARDING: '/ob',
  RESET_PASSWORD: '/reset-password',
  RESET_PASSWORD_WITH_LANG: '/:lang/reset-password',
  LOCAL_AUTH: '/local-auth',
  AUTH: '/auth',
  SIGNIN: '/signin',
  SIGNIN_WITH_LANG: '/:lang/signin',
  SIGNUP: '/signup',
  SIGNUP_WITH_LANG: '/:lang/signup',
  SANDBOX: '/sandbox',
  PREMIUM_PROCESS: '/premium-process',
  ACTIVITY: '/activity',
  UPLOAD_ACTIVITY: '/upload-activity',
  RESOURCES: '/resources',
  MESSAGES: '/messages',
  CALENDAR: '/calendar',
  PORTFOLIO: '/portfolio',
  TEACHER_PROFILE: '/teacher-profile',
  CLASSROOM_DETAILS: '/classroom-details',
  CENTER_SETTINGS: '/center-view',
  STUDENT_ARTICLE: '/student-article',
  // STUDENT_ACTIVITY: '/student-activity',
};

export const menuViews = [
  '/',
  APP_SECTIONS_PATHS.DAP,
  APP_SECTIONS_PATHS.MY_PLANS,
  APP_SECTIONS_PATHS.CATALOG,
  APP_SECTIONS_PATHS.PROGRESS,
  APP_SECTIONS_PATHS.MILESTONES,
  APP_SECTIONS_PATHS.SETTINGS,
  APP_SECTIONS_PATHS.ADD_STUDENTS,
  APP_SECTIONS_PATHS.STUDENTS_PROFILE,
  APP_SECTIONS_PATHS.USER_PROFILE,
  APP_SECTIONS_PATHS.ACTIVITY,
  APP_SECTIONS_PATHS.UPLOAD_ACTIVITY,
  APP_SECTIONS_PATHS.RESOURCES,
  APP_SECTIONS_PATHS.MESSAGES,
  APP_SECTIONS_PATHS.PORTFOLIO,
];

export const menuItems = [
  {
    title: 'MENU.HOME',
    icon: 'dap',
    route: APP_SECTIONS_PATHS.DAP,
  },
  {
    title: 'MENU.CATALOG',
    icon: 'catalog',
    route: APP_SECTIONS_PATHS.CATALOG,
  },
  {
    title: 'MENU.CALENDAR',
    icon: 'calendar',
    route: APP_SECTIONS_PATHS.CALENDAR,
  },
  {
    title: 'MENU.COMMUNITY',
    icon: 'Messages',
    route: APP_SECTIONS_PATHS.MESSAGES,
  },
  {
    title: 'MENU.RESOURCES',
    icon: 'resources',
    route: APP_SECTIONS_PATHS.RESOURCES,
  },
  {
    title: 'MENU.PORTFOLIO',
    icon: 'portfolio',
    route: APP_SECTIONS_PATHS.PORTFOLIO,
  },
  {
    title: 'MENU.SETTINGS',
    icon: 'Gear',
    route: APP_SECTIONS_PATHS.SETTINGS,
  },
];

export const RESOURCES_FOLDER_PARAMS = {
  CATEGORY_ID: ':categoryId',
  SUBCATEGORY_ID: ':subcategoryId',
};

export const RESOURCES_FOLDER_ROUTES = {
  SUBCATEGORY: `${APP_SECTIONS_PATHS.RESOURCES}/category/${RESOURCES_FOLDER_PARAMS.CATEGORY_ID}`,
  RESOURCES: `${APP_SECTIONS_PATHS.RESOURCES}/category/${RESOURCES_FOLDER_PARAMS.CATEGORY_ID}/subcategory/${RESOURCES_FOLDER_PARAMS.SUBCATEGORY_ID}/resources`,
};

export const COLLECTION_PARAMS = {
  COLLECTION_ID: ':collectionId',
  SUBCOLLECTION_ID: ':subcollectionId',
};

export const COLLECTION_ROUTES = {
  SUBCOLLECTIONS: `${APP_SECTIONS_PATHS.CATALOG}/collection/${COLLECTION_PARAMS.COLLECTION_ID}/subcollection/`,
  SUBCOLLECTIONS_ACTIVITY: `${APP_SECTIONS_PATHS.CATALOG}/collection/${COLLECTION_PARAMS.COLLECTION_ID}/subcollection/${COLLECTION_PARAMS.SUBCOLLECTION_ID}/activities`,
};

export const BREADCRUMBS = {
  HOME: (t) => ({ name: t('MENU.HOME'), url: APP_SECTIONS_PATHS.DAP }),
  CATALOG: (t) => ({ name: t('MENU.CATALOG'), url: APP_SECTIONS_PATHS.CATALOG }),
  STUDENT_PROFILE: (t) => ({ name: t('STUDENT_PROFILE.TITLE'), url: APP_SECTIONS_PATHS.STUDENTS_PROFILE }),
};
